import { IconAppConnect } from '@components/icons/app-connect';
import { IconCompany } from '@components/icons/company';
import { IconDepartment } from '@components/icons/department';
import { IconJobboard } from '@components/icons/jobboard';
import { IconLabel } from '@components/icons/label';
import { IconLocation } from '@components/icons/location';
import { IconTeam } from '@components/icons/team';
import { IconTemplate } from '@components/icons/template';
import { IconWorkType } from '@components/icons/work-type';
import { isNotFalse } from '@utils/types';

import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

export const useCompanySettingsNavigationItems = () => {
  const { current, t } = useStore();
  const { hasRolePermission } = usePermissions();

  return [
    hasRolePermission('company:details-settings') && {
      icon: <IconCompany />,
      path: '/settings/company',
      label: t('navigation.settings.company'),
    },
    current.info.isEnterprise && {
      icon: <IconDepartment />,
      path: '/settings/departments',
      label: t('navigation.settings.departments'),
    },
    hasRolePermission('locations:view') && {
      icon: <IconLocation />,
      path: '/settings/locations',
      label: t('navigation.settings.locations'),
    },
    hasRolePermission('worktypes:view') && {
      icon: <IconWorkType />,
      path: '/settings/worktypes',
      label: t('navigation.settings.worktypes'),
    },
    hasRolePermission('team:view') && {
      icon: <IconTeam />,
      path: '/settings/team',
      label: t('navigation.settings.team'),
    },
    {
      icon: <IconTemplate />,
      path: '/settings/templates',
      label: t('navigation.settings.templates'),
    },
    hasRolePermission('joblabels:view') && {
      icon: <IconLabel />,
      path: '/settings/labels',
      label: t('navigation.settings.labels'),
    },
    {
      icon: <IconJobboard />,
      path: '/settings/jobboards',
      label: t('navigation.settings.jobboards'),
    },
    {
      icon: <IconAppConnect />,
      path: '/settings/apps',
      label: t('navigation.settings.integrations'),
    },
  ].filter(isNotFalse);
};
